export default "__VITE_ASSET__Gs8rpqiE__"